import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Tune from '../../../../../static/tune.svg';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import * as styles from './toolbar.module.scss';
import { ToolbarQuery } from '../../../../../graphql-types';

interface IToolbarProps {
  nbResults: number;
  filtersIsProvided: boolean;
  setOpenModal: (open: boolean) => void;
}

export const Toolbar = ({ nbResults, filtersIsProvided, setOpenModal }: IToolbarProps) => {
  const { lang } = usePageContext();
  const { sanityTranslations } = useStaticQuery<ToolbarQuery>(QUERY);

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <div className={styles.results}>
          <b className={styles.nb}>{`${nbResults} `}</b>
          <span>{sanityTranslations?._rawResultLabel?.[lang]}</span>
        </div>
        {/* {filtersIsProvided && (
          <h3 className={styles.title}>{sanityTranslations?._rawModalTitleDesktop?.[lang]}</h3>
        )} */}
        {filtersIsProvided && (
          <div
            role="button"
            onKeyDown={() => setOpenModal(true)}
            tabIndex={0}
            onClick={() => setOpenModal(true)}
            className={styles.filters}
          >
            {sanityTranslations?._rawFilterLabel?.[lang]}
            <Tune />
          </div>
        )}
      </div>
    </div>
  );
};

const QUERY = graphql`
  query Toolbar {
    sanityTranslations {
      _rawFilterLabel
      _rawResultLabel
      _rawModalTitleDesktop
    }
  }
`;
